export const getApiError = (ex?: any, defaultMessage = 'Something went wrong') => {
    const messages = ex?.response?.data?.messages;
    const mainErrorMessage = ex?.response?.data?.mainErrorMessage;
    if (messages && Object.keys(messages).length > 0) {
        const key = Object.keys(messages)[0];
        return messages[key];
    } else if (mainErrorMessage) {
        return mainErrorMessage;
    }
    return defaultMessage;
};
